package com.milta.core.localization

/**
 * MIL-99 — deliveries whose address was not located (GeocodeStatus != Geocoded). The route's
 * creator is warned before optimizing/sending and can correct the address; a driver receiving an
 * Enterprise route is only informed (badge), never offered a correction. Shared by mobile and web.
 * Cancel buttons reuse [CommonStrings].
 */
data class UnlocatedDeliveryStrings(
    /** Warning dialog title, exactly one unlocated delivery. */
    val warningTitleSingular: String,
    /** Warning dialog title, contains a "%d" placeholder replaced by the count (2+). */
    val warningTitlePlural: String,
    val warningMessage: String,
    /** Closes the warning dialog so the user can correct the addresses. */
    val fixAction: String,
    /** Proceeds anyway — the backend places these stops at the end of the route. */
    val continueWithoutAction: String,
    /** Shown after optimization, exactly one stop not placed. */
    val unplacedStopsSingular: String,
    /** Shown after optimization, contains a "%d" placeholder replaced by the count (2+). */
    val unplacedStopsPlural: String,
    /** Per-stop action (creator only, before sending/start) and title of its dialog. */
    val fixAddressAction: String,
    /** Driver view of a received Enterprise route — informative badge only. */
    val unlocatedBadge: String,
)

fun UnlocatedDeliveryStrings.warningTitle(count: Int): String =
    if (count == 1) warningTitleSingular else warningTitlePlural.replace("%d", count.toString())

fun UnlocatedDeliveryStrings.unplacedStops(count: Int): String =
    if (count == 1) unplacedStopsSingular else unplacedStopsPlural.replace("%d", count.toString())
